import { Component, Input } from '@angular/core';

/** Détail des prestations de pose, réparties en inclus / à valider / non compris. */
@Component({
  selector: 'ng-casto-installation-details',
  templateUrl: './installation-details.component.html',
  styleUrls: ['./installation-details.component.scss'],
})
export class InstallationDetailsComponent {
  /** Libellés des prestations incluses dans l'estimation. */
  @Input() included: string[] = [];
  /** Libellés des prestations à valider lors du relevé technique. */
  @Input() toValidate: string[] = [];
  /** Libellés des prestations non comprises dans l'estimation. */
  @Input() excluded: string[] = [];
  /** Remplace les listes de prestations par des squelettes pendant le chargement. */
  @Input() loading: boolean;

  /** Largeurs des lignes de squelette de chaque colonne. */
  protected readonly skeletonWidths = [
    ['90%', '75%', '85%', '60%', '80%'],
    ['85%', '65%'],
    ['80%', '70%', '90%'],
  ];
}
